/**
 * NZ-friendly date formatters. The vault and purchase APIs serialize dates as ISO YYYY-MM-DD
 * (or full ISO datetime). New Zealand users expect DD/MM/YYYY display.
 */

const pad = (n) => String(n).padStart(2, "0");

export function formatDateNZ(input) {
 if (!input) return "";
 let d;
 if (typeof input === "string") {
 // YYYY-MM-DD or full ISO. Parse as local date if YYYY-MM-DD only (no TZ shift).
 const m = input.match(/^(\d{4})-(\d{2})-(\d{2})/);
 if (m) {
 d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
 } else {
 d = new Date(input);
 }
 } else if (input instanceof Date) {
 d = input;
 } else {
 return "";
 }
 if (isNaN(d.getTime())) return "";
 return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

export function formatDateTimeNZ(input) {
 if (!input) return "";
 const d = input instanceof Date ? input : new Date(input);
 if (isNaN(d.getTime())) return "";
 return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
